import "./articleinfo.scss";

const ArticleInfo = () => {
  return (
    <article className="article-info">
      <div className="article-info__sources">
        <span>Sorumluluk Beyanı:</span>
      </div>
      <div className="article-info__footer">
        <div className="article-card">
          <p>
            Burada yer alan yatırım bilgi, yorum ve tavsiyeleri yatırım
            danışmanlığı kapsamında değildir. Yatırım danışmanlığı; aracı
            kurumlar, portföy yönetim şirketleri, mevduat kabul etmeyen bankalar
            ile müşteri arasında imzalanacak yatırım danışmanlığı sözleşmesi
            çerçevesinde sunulmaktadır. Burada yer alan ve hiçbir şekilde
            yönlendirici nitelikte olmayan içerik, yorum ve tavsiyeler ise genel
            niteliktedir. Bu tavsiyeler mali durumunuz ile risk ve getiri
            tercihlerinize uygun olmayabilir. Bu nedenle, sadece burada yer alan
            bilgilere dayanılarak yatırım kararı verilmesi beklentilerinize
            uygun sonuçlar doğurmayabilir. Bu sayfalarda yer alan çeşitli bilgi
            ve görüşlere dayanılarak yapılacak ileriye dönük yatırımlar ve
            ticari işlemlerin sonuçlarından ya da ortaya çıkabilecek zararlardan
            Fibabanka A.Ş sorumlu tutulamaz.
          </p>
        </div>
      </div>
    </article>
  );
};

export default ArticleInfo;
